import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MembersInformationRoutingModule } from './members-information-routing.module';
import { BootstrapMembersInformationComponent } from './components/bootstrap-members-information/bootstrap-members-information.component';
import { CommonPageComponentsModule } from '../../../common-page-components/common-page-components.module';
import { ComponentsModule } from '../../../library/components/components/components.module';
import { ServicesModule } from 'world-archery-lib';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

@NgModule({
  declarations: [BootstrapMembersInformationComponent],
  imports: [
    CommonModule,
    MembersInformationRoutingModule,
    CommonPageComponentsModule,
    ComponentsModule,
    ServicesModule,
    LeafletModule
  ]
})
export class MembersInformationModule { }
